export default __webpack_public_path__ + "static/media/Distribution Design Overview.1fcf3733.pdf";